import { BrowserRouter, Route, Routes } from 'react-router-dom';

import CheckInDetailPage from '../../vendor-checkin/components/check-in-detail/checkin-detail';
import CheckInSummaryPage from '../../vendor-checkin/components/check-in-summary/checkin-summary';
import CheckoutComponent from '../../vendor-checkin/components/checkout/checkout-component';
import Home from '../../screens/Home';
import MessageCenter from '../../vendor-checkin/components/message-center/message-center';

const Routers = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/checkout' element={<CheckoutComponent />} />
        <Route path='/checkin-summary' element={<CheckInSummaryPage />} />
        <Route path='/checkin-detail' element={<CheckInDetailPage />} />
        <Route path='/message-center' element={<MessageCenter />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Routers;
